export const journalFrag = `
    id
    code
    name
    type
    isDefault
    accountId
    account {
        id
        code
        name
    }
    currencyId
    currency {
        id
        code
        name
    }
`;
